// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { D3eService } from 'src/services/d3e-service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../../../../services/notification-service';

@Component({
    selector: 'app-upload-dialog',
    templateUrl: './upload-dialog.component.html',
    styleUrls: ['./upload-dialog.component.scss'],
    standalone: false
})
export class UploadDialogComponent {

  file: File = null;

  fUnknownError: string;

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    public d3eService: D3eService,
    private translate: TranslateService,
    private notification: NotificationService,
  ) {
    const keys = ['ERROR_OCCURRED_UNKNOWN'];
    this.translate.get(keys).subscribe(vals => {
      this.fUnknownError = vals['ERROR_OCCURRED_UNKNOWN'];
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  setFile(fileInput) {
    this.file = fileInput.files[0];
  }

  upload() {
    this.d3eService.getSubjectForCertificate(this.file).subscribe(
      result => {
      this.dialogRef.close(result);
      },
      () => {
        this.notification.showError(this.translate.instant('ERROR_INVALID_CERTIFICATE_UPLOAD'));
      });
  }
}
